module.exports = __webpack_public_path__ + "static/media/icon-new-progress-active.86946ad5.svg";